var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 56.3 56.3",
    enableBackground: "new 0 0 56.3 56.3",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_1_",
    opacity: 0.98,
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    cx: 28.1,
    cy: 28.1,
    r: 27.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M28.1,41.5c-2.2,0-4.3,0-6.5,0c-3.9,0-7.1-3.2-7.1-7.1c0-4.2,0-8.3,0-12.5c0-3.7,3-7,6.7-7   c4.6-0.1,9.2-0.1,13.8,0c3.8,0.1,6.8,3.3,6.8,7.1c0,4.1,0,8.2,0,12.3c0,4-3.2,7.1-7.1,7.2C32.4,41.5,30.2,41.5,28.1,41.5z    M28.1,17.3c-2,0-4.1,0-6.1,0c-2.9,0-5,2.1-5.1,5c0,4,0,7.9,0,11.9c0,2.8,2.2,5,5.1,5c4.1,0,8.1,0,12.2,0c2.9,0,5-2.2,5-5.1   c0-3.9,0-7.8,0-11.7c0-2.9-2.2-5.1-5.1-5.1C32.2,17.3,30.2,17.3,28.1,17.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M36.8,21c0,0.9-0.7,1.5-1.5,1.6c-0.9,0-1.6-0.7-1.6-1.5c0-0.9,0.7-1.6,1.6-1.6C36.2,19.5,36.8,20.1,36.8,21   z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M28.1,21.4c-3.8,0-6.9,3.1-6.9,6.9c0,3.8,3,6.8,6.8,6.8c3.8,0,6.9-3,6.9-6.8C35,24.4,31.9,21.4,28.1,21.4z    M28.1,32.6c-2.4,0-4.4-2-4.4-4.4c0-2.4,2-4.4,4.4-4.4c2.4,0,4.4,2,4.4,4.4C32.5,30.7,30.5,32.6,28.1,32.6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.6b0499f80c01df1f8c36d3f2d1fc3a3d.svg";
export { ForwardRef as ReactComponent };